export default "__VITE_ASSET__40c067c6__"